import { render, staticRenderFns } from "./DisabilityCarPage.vue?vue&type=template&id=277fd75c"
import script from "./DisabilityCarPage.vue?vue&type=script&lang=js"
export * from "./DisabilityCarPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports